<template>
  <v-card class="mx-auto" :disabled="loading" :loading="loading">
          
    <v-tabs v-model="type_tab">
      <v-tabs-slider color="orange"></v-tabs-slider>
      <v-tab v-for="(type, i) in type_fee" :key="i">
        <v-card-title>
          {{ $t(type.title) }}
        </v-card-title>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="type_tab" touchless>
      <v-tab-item v-for="(type, i) in type_fee" :key="i">
          <v-card-subtitle>
            {{ type.sub_title }}
          </v-card-subtitle>
      </v-tab-item>
  </v-tabs-items>

    <v-card-text v-if="type_tab == 0" class="px-1 px-md-3 px-xl-6">
      <v-tabs v-model="level_tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab v-for="(level, i) in levels" :key="i">
          <h3>
            {{ level.LEVEL_NAME_EN }}
          </h3>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="level_tab" touchless>
        <v-tab-item v-for="(level, i) in levels" :key="i">
          <v-card flat>
            <v-card-text class="px-1 px-md-3 px-xl-6">
              <v-form v-model="form_validate_status" ref="form">
                <v-row>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="selected_year"
                      :items="years"
                      outlined
                      dense
                      :label="$t('config_teach_table.year')"
                      hide-details
                      :rules="year_rules"
                      required
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="selected_semester"
                      :items="semesters"
                      outlined
                      dense
                      :label="$t('config_teach_table.semester')"
                      hide-details
                      :rules="semester_rules"
                      required
                    />
                  </v-col>
                  <v-col cols="12" md="3" offset-md="3">
                    <v-text-field
                      label="ค้นหาจากรหัสนักศึกษา"
                      v-model="find_student_id"
                      outlined
                      dense
                      filled
                      rounded
                      append-icon="mdi-magnify"
                      class="shrink"
                      clearable
                    />
                  </v-col>
                </v-row>
              </v-form>

              <v-btn
                color="success"
                @click="
                  $refs.addEditDialog.open_add_modal(
                    selected_level,
                    selected_year,
                    selected_semester
                  )
                "
                class="mt-3"
                v-if="form_validate_status"
              >
                <v-icon>mdi-plus</v-icon>เพิ่มข้อมูล
              </v-btn>
              <v-simple-table
                min-height="300px"
                class="mt-3 text-no-wrap text-center"
                v-if="data.length > 0"
              >
                <thead class="blue-grey darken-1">
                  <tr>
                    <th class="white--text text-center font-weight-regular">
                      แก้ไข
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ลบ
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      #
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ปีการศึกษา
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      รหัสนักศึกษา
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ชื่อ-สกุล
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ค่าธรรมเนียมการศึกษา (บาท)
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      คณะ
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ระดับการศึกษา
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      หมายเหตุ
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      วันที่บันทึก
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ผู้บันทึก
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="data.length == 0 && !loading">
                    <td colspan="10" class="last-cell">
                      <p class="text-center text-secondary mb-0">no result</p>
                    </td>
                  </tr>
                  <tr v-for="(item, index) in data" :key="index">
                    <td>
                      <v-btn
                        small
                        color="warning"
                        v-on:click="
                          $refs.addEditDialog.open_edit_modal(
                            item.level,
                            item.year,
                            item.semester,
                            item
                          )
                        "
                      >
                        <v-icon>mdi-pencil</v-icon
                        >{{ $t("config_academic.edit") }}
                      </v-btn>
                    </td>
                    <td>
                      <v-btn
                        small
                        color="error"
                        @click="
                          $refs.deleteDialog.open_delete_modal(
                            item.level,
                            item.year,
                            item.semester,
                            item
                          )
                        "
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.semester }}/{{ item.year }}</td>
                    <td>{{ item.student_id }}</td>
                    <td>
                      {{
                        `${item.std_info.prename_th}${item.std_info.name_th} ${item.std_info.surname_th}`
                      }}
                    </td>
                    <td>
                      {{ numberWithCommas(item.tuition_fee) }}
                    </td>
                    <td>
                      {{ item.std_info.faculty_name }}
                    </td>
                    <td>
                      <span
                        v-if="
                          item.std_info.sub_level_id == 1 && selected_level == 2
                        "
                        class="red--text"
                      >
                        นศ. 4+1</span
                      >
                      <span v-else>{{ item.std_info.level_name_th }}</span>
                    </td>
                    <td>{{ item.remark }}</td>
                    <td>{{ dt(item.updated_at) }}</td>
                    <td class="last-cell">{{ item.operator }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <v-card-text v-if="type_tab == 1" class="px-1 px-md-3 px-xl-6">
      <v-card flat>
        <v-card-text class="px-1 px-md-3 px-xl-6">
          <v-form v-model="form_validate_status" ref="form">
            <v-row>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="selected_year"
                  :items="years"
                  outlined
                  dense
                  :label="$t('config_teach_table.year')"
                  hide-details
                  :rules="year_rules"
                  required
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="selected_semester"
                  :items="semesters"
                  outlined
                  dense
                  :label="$t('config_teach_table.semester')"
                  hide-details
                  :rules="semester_rules"
                  required
                />
              </v-col>
              <v-col cols="12" md="3" offset-md="3">
                <v-text-field
                  label="ค้นหาจากรหัสนักศึกษา"
                  v-model="find_student_id"
                  outlined
                  dense
                  filled
                  rounded
                  append-icon="mdi-magnify"
                  class="shrink"
                  clearable
                />
              </v-col>
            </v-row>
          </v-form>

          <v-btn
            color="success"
            @click="
              $refs.addEditDialog.open_add_modal(
                selected_level,
                selected_year,
                selected_semester
              )
            "
            class="mt-3"
            v-if="form_validate_status"
          >
            <v-icon>mdi-plus</v-icon>เพิ่มข้อมูล
          </v-btn>
          <v-simple-table
            min-height="300px"
            class="mt-3 text-no-wrap text-center"
            v-if="data.length > 0"
          >
            <thead class="blue-grey darken-1">
              <tr>
                <th class="white--text text-center font-weight-regular">
                  แก้ไข
                </th>
                <th class="white--text text-center font-weight-regular">
                  ลบ
                </th>
                <th class="white--text text-center font-weight-regular">
                  #
                </th>
                <th class="white--text text-center font-weight-regular">
                  ปีการศึกษา
                </th>
                <th class="white--text text-center font-weight-regular">
                  รหัสนักศึกษา
                </th>
                <th class="white--text text-center font-weight-regular">
                  ชื่อ-สกุล
                </th>
                <th class="white--text text-center font-weight-regular">
                  ค่าธรรมเนียมการศึกษา (บาท)
                </th>
                <th class="white--text text-center font-weight-regular">
                  ค่าอุดหนุนทางการศึกษา (บาท)
                </th>
                <th class="white--text text-center font-weight-regular">
                  คณะ
                </th>
                <th class="white--text text-center font-weight-regular">
                  หมายเหตุ
                </th>
                <th class="white--text text-center font-weight-regular">
                  วันที่บันทึก
                </th>
                <th class="white--text text-center font-weight-regular">
                  ผู้บันทึก
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="data.length == 0 && !loading">
                <td colspan="10" class="last-cell">
                  <p class="text-center text-secondary mb-0">no result</p>
                </td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td>
                  <v-btn
                    small
                    color="warning"
                    v-on:click="
                      $refs.addEditDialog.open_edit_modal(
                        item.level,
                        item.year,
                        item.semester,
                        item
                      )
                    "
                  >
                    <v-icon>mdi-pencil</v-icon
                    >{{ $t("config_academic.edit") }}
                  </v-btn>
                </td>
                <td>
                  <v-btn
                    small
                    color="error"
                    @click="
                      $refs.deleteDialog.open_delete_modal(
                        item.level,
                        item.year,
                        item.semester,
                        item
                      )
                    "
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
                <td>{{ index + 1 }}</td>
                <td>{{ item.semester }}/{{ item.year }}</td>
                <td>{{ item.student_id }}</td>
                <td>
                  {{
                    `${item.std_info.prename_th}${item.std_info.name_th} ${item.std_info.surname_th}`
                  }}
                </td>
                <td>
                  {{ numberWithCommas(item.tuition_fee) }}
                </td>
                <td>
                  {{ numberWithCommas(item.subsidy_fee ?? 0) }}
                </td>
                <td>
                  {{ item.std_info.faculty_name }}
                </td>
                <td>{{ item.remark }}</td>
                <td>{{ dt(item.updated_at) }}</td>
                <td class="last-cell">{{ item.operator }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-card-text>


    <ConfigIndividualTuitionFeeAddEditDialog
      ref="addEditDialog"
      :toggle_loading="toggle_loading"
      :fetch_data="fetch_data"
      :type_tab="type_tab"
    />

    <ConfigIndividualTuitionFeeDeleteDialog
      ref="deleteDialog"
      :toggle_loading="toggle_loading"
      :fetch_data="fetch_data"
      :type="type_tab"
    />
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import { numberWithCommas } from "@/helper/format";
import ConfigIndividualTuitionFeeAddEditDialog from "./components/ConfigIndividualTuitionFeeAddEditDialog";
import ConfigIndividualTuitionFeeDeleteDialog from "./components/ConfigIndividualTuitionFeeDeleteDialog";
import { dateTimeFromDBTranslatorFull as dt } from "@/helper/translator";
import ConfigProvider from "@/services/config.provider";

const semesters = ["1", "2", "3"].sort((a, b) => b - a);
const configService = new ConfigProvider();

export default {
  name: "ConfigIndividualTuitionFee",
  data: () => ({
    loading: false,
    level_tab: 1,
    levels: [
      {
        LEVEL_ID: "1",
        LEVEL_NAME_EN: "ปริญญาตรี",
        LEVEL_NAME_TH: "ปริญญาตรี",
      },
      {
        LEVEL_ID: "2",
        LEVEL_NAME_EN: "บัณฑิตศึกษา (4+1, โท, เอก)",
        LEVEL_NAME_TH: "บัณฑิตศึกษา (4+1, โท, เอก)",
      },
    ],

    type_tab: 0,
    type_fee: [
      {
        id: 1,
        title: "officer.config_individual_tuition_fee",
        sub_title: "สำหรับระบุค่าเทอม นศ.กรณีพิเศษไว้สำหรับปีการศึกษาที่ยังมาไม่ถึง (***กรณีที่ นศ.ลงทะเบียนแล้วจะไม่สามารถเพิ่มหรือแก้ไขข้อมูลเมนูนี้ได้เคสนี้ให้แก้ค่าเทอมที่เมนูเดิมนะคะ***)",
      },
      {
        id: 2,
        title: "officer.config_subsidy_fee",
        sub_title: "สำหรับระบุค่าเทอมและค่าอุดหนุนทางการศึกษา นศ.กรณีพิเศษไว้สำหรับปีการศึกษาที่ยังมาไม่ถึง (***กรณีที่ นศ.ลงทะเบียนแล้วจะไม่สามารถเพิ่มหรือแก้ไขข้อมูลเมนูนี้ได้เคสนี้ให้แก้ค่าเทอมที่เมนูเดิมนะคะ***)",
      }
    ],

    years: [],
    semesters: semesters,
    selected_level: null,
    selected_year: null,
    selected_semester: null,
    find_student_id: null,
    year_rules: [(v) => !!v || "Year is required"],
    semester_rules: [(v) => !!v || "Semester is required"],

    form_validate_status: false,

    data: [],
  }),
  components: {
    ConfigIndividualTuitionFeeAddEditDialog,
    ConfigIndividualTuitionFeeDeleteDialog,
  },

  methods: {
    dt,
    numberWithCommas,

    async fetch_data() {

      if (this.type_tab == 1) {
        this.selected_level = 1; 
      }else {
        this.selected_level = this.levels[this.level_tab].LEVEL_ID;
      }

      this.loading = true;

      const response = await configService
        .getIndividualTuitionFee({
          level: this.selected_level,
          year: this.selected_year,
          semester: this.selected_semester,
          student_id: this.find_student_id,
          type_fee: this.type_tab,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });

      if (response) this.data = response;

      this.loading = false;
    },

    clear_data() {
      this.data = [];
    },

    toggle_loading(status) {
      this.loading = status;
    },
  },

  watch: {
    form_validate_status: {
      handler: function (newVal) {
        this.clear_data();
        if (
          newVal === true &&
          this.selected_year !== null &&
          this.selected_semester !== null
        )
          this.fetch_data();
      },
    },
    type_tab() {
      if (
        this.form_validate_status === true ||
        this.find_student_id.length === 8
      ) {
        this.fetch_data();
      }
    },
    level_tab(newVal) {
      this.selected_level = this.levels[newVal].LEVEL_ID;
      if (
        this.form_validate_status === true ||
        this.find_student_id.length === 8
      ) {
        this.fetch_data();
      }
    },
    selected_year: {
      handler: function () {
        this.clear_data();
        if (this.form_validate_status === true && this.selected_year !== null)
          this.fetch_data();
      },
    },
    selected_semester: {
      handler: function () {
        this.clear_data();
        if (
          this.form_validate_status === true &&
          this.selected_semester !== null
        )
          this.fetch_data();
      },
    },
    find_student_id: {
      handler: function () {
        this.clear_data();
        if (
          (this.find_student_id && this.find_student_id.length === 8) ||
          this.find_student_id === null ||
          this.find_student_id === ""
        ) {
          this.fetch_data();
        }
      },
    },
  },

  created() {
    const maxYear = parseInt(dayjs().format("BBBB")) + 4;
    for (let year = 2563; year <= maxYear; year++) this.years.push(year);
    this.years.sort().reverse();
    this.selected_level = this.levels[this.level_tab].LEVEL_ID;
  },
};
</script>

<style>
th {
  letter-spacing: 1px;
}
.last-cell {
  border-right-width: 1px;
}
</style>
